export default __webpack_public_path__ + "static/media/day2.26cd71c7.png";